import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.funding_requirements.major_shareholder_check_title',
        defaultMessage: 'Add directors and shareholders'
    },
    caption: {
        id: '_.funding_requirements.major_shareholder_check_caption',
        defaultMessage: 'Add details of all directors and major shareholders.'
    },
    action: {
        id: '_.funding_requirements.major_shareholders_check_action',
        defaultMessage: 'Add details'
    },
    pending: {
        id: '_.funding_requirements.major_shareholders_check_action_pending',
        defaultMessage: 'Pending'
    }
});
